import { strings } from 'APP_ROOT/localization';

export default class MapboxToggleGeofenceControl {

    mapboxControlShouldShowGeofence;
    mapboxControlCallback;

    constructor(showGeofenceByDefault, callbackForButtonEventListener) {
        this.mapboxControlShouldShowGeofence = showGeofenceByDefault;
        this.mapboxControlCallback = callbackForButtonEventListener;
    }

    buttonEventListener = () => {

        this.mapboxControlShouldShowGeofence = !this.mapboxControlShouldShowGeofence; // toggle
        this.mapboxControlCallback(this.mapboxControlShouldShowGeofence);
    }

    onStyleChange() {

        if (!this.map) {
            console.error("onStyleChange triggered while map property is invalid (" + (this.map) + "). Doing nothing.");
            return;
        }

        this.mapboxControlCallback(this.mapboxControlShouldShowGeofence);
    }

    onAdd(map) {
        this.map = map;
        this.container = this.container();
        return this.container;
    }

    onRemove() {
        this.container.parentNode.removeChild(this.container);
        this.mapboxComponentClassCallback = undefined;
        this.map = undefined;
    }

    button() {

        var iconElement = document.createElement('i');
        iconElement.className = 'material-icons';
        iconElement.innerText = 'bubble_chart';

        var buttonElement = document.createElement('button');
        buttonElement.id = 'showGeofenceBtn';
        buttonElement.title = strings.map_controls_label_toggle_geofences;
        buttonElement.appendChild(iconElement);

        buttonElement.addEventListener('click', this.buttonEventListener);

        return buttonElement;
    }

    container() {
        var buttonWrapperContainer = document.createElement('div');
        buttonWrapperContainer.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
        buttonWrapperContainer.appendChild(this.button());
        return buttonWrapperContainer;
    }
}
